import React from 'react';

import useTranslation from 'hooks/use-translation';
import { BaseModal } from '../base-modal';
import { DutchiePayTextBody, DutchiePayConfirmationButton } from '../../components';

type LearnMoreModalProps = {
  onCloseModal: () => void;
};

export function DutchiePayLearnMoreModal({ onCloseModal }: LearnMoreModalProps): JSX.Element {
  const { t, Trans } = useTranslation();
  return (
    <BaseModal onCloseModal={onCloseModal} heading={t('dutchiePay.yourAccount', 'Your Dutchie account')} hideLogo>
      <DutchiePayTextBody>
        <Trans i18nKey='dutchiePay.dutchiePowers'>
          <a href='/'>Dutchie.com</a> powers online ordering for thousands of cannabis dispensaries, and{' '}
          <strong>you created an account</strong> when you placed an order through Dutchie.
        </Trans>
      </DutchiePayTextBody>

      <DutchiePayTextBody>
        {t(
          'dutchiePay.existingAccount',
          'With an existing account, you’re all set to easily register for Dutchie Pay.'
        )}
      </DutchiePayTextBody>

      <DutchiePayConfirmationButton onClick={onCloseModal}>
        {t('dutchiePay.gotIt', 'Got it, thanks!')}
      </DutchiePayConfirmationButton>
    </BaseModal>
  );
}
